import TableComponentsContainer from "../../Componant/BootstrapTables/TableComponents";

const TableComponents = () => {
  return (
    <div className="page-body">
      <TableComponentsContainer />
    </div>
  );
};

export default TableComponents;
